import styled from 'styled-components'

import { buttonStyle } from '../../../styled/pageStyle'

import { siteBreakPoints, colors } from '../../../consts/styleConsts'
const { grey, darkGrey2 } = colors.grey
const { primary } = colors
const { small, xSmall } = siteBreakPoints
const container = 61.81
const width1400 = 1400

export const SocialShareWrapper = styled.div`
  margin-top: 7.27rem;
  margin-bottom: 9.09rem;
  width: 100%;
  position: relative;
  padding: 0 calc((100vw - ${container}rem) / 2);
  @media screen and (max-width: ${width1400}px) {
    width: 100%;
    padding-left: 0;
    padding-right: 0;
  }
  @media screen and (max-width: ${small}px) {
    padding: 0 1.25rem;
  }
`
export const SocialShareContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: ${width1400}px) {
    flex-direction: column;
    align-items: center;
  }
`
export const SocialShareTextWrapper = styled.div`
  min-width: 27.5rem;
  max-width: 27.5rem;
  @media screen and (max-width: ${width1400}px) {
    margin-bottom: 4.18rem;
    max-width: 31.81rem;
  }
  @media screen and (max-width: ${small}px) {
    max-width: 100%;
    min-width: 100%;
  }
`
export const SocialShareTitle = styled.span`
  color: ${primary};
  font-family: Plex-Bold;
  font-size: 2.72rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 3.5rem;
  margin-bottom: 1.36rem;
  display: inline-block;
  @media screen and (max-width: ${small}px) {
    font-size: 1.75rem;
    line-height: 3.31rem;
    margin-bottom: 0.62rem;
  }
`
export const SocialShareText = styled.span`
  color: ${darkGrey2};
  font-family: Plex-Light;
  font-size: 1.3rem;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 2rem;
  display: inline-block;
  @media screen and (max-width: ${small}px) {
    font-size: 1.12rem;
    line-height: 1.43rem;
  }
`
export const SocialButtonsWrapper = styled.div`
  width: 31.81rem;
  display: flex;
  justify-content: space-between;
  text-align: center;
  position: relative;
  @media screen and (max-width: ${small}px) {
    max-width: 100%;
  }
  @media screen and (max-width: ${xSmall}px) {
    max-width: 108%;
  }
`
export const ShareBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
export const ShareBoxTitle = styled.span`
  margin-bottom: 2.13rem;
  color: ${grey};
  font-family: Plex-Bold;
  font-size: 1.45rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 1.9rem;
  display: inline-block;
  @media screen and (max-width: ${small}px) {
    font-size: 1.12rem;
    margin-bottom: 0.93rem;
  }
`
export const ShareBoxBtn = styled.a`
  ${buttonStyle};
  min-width: auto !important;
`
export const ShareEyeBg = styled.img`
  width: 30rem;
  position: absolute;
  top: 50%;
  left: 56%;
  transform: translate(-50%, -50%);
  opacity: 0.13;
  pointer-events: none;
  @media screen and (max-width: ${small}px) {
    left: 50%;
    width: 18.75rem;
  }
`
